/**
 * In-memory Knex connection using SQLite :memory:.
 * Replaces InMemoryAdapter for persistent entities with adapter: 'memory'.
 * Tables are ephemeral — recreated each boot.
 *
 * Note: serializeForDb in base.service.ts detects 'better-sqlite3' client
 * to decide JSON stringification. This client name is relied upon.
 */
import knex, { type Knex } from 'knex'

let memoryKnex: Knex | null = null

/**
 * Get or create the shared SQLite :memory: Knex instance.
 * Singleton — persists for the process lifetime.
 */
export function getMemoryKnex(): Knex {
  if (!memoryKnex) {
    memoryKnex = knex({
      client: 'better-sqlite3',
      connection: { filename: ':memory:' },
      useNullAsDefault: true,
      pool: {
        afterCreate: (conn: any, cb: () => void) => {
          conn.pragma('foreign_keys = ON')
          cb()
        }
      }
    })
  }
  return memoryKnex
}

/**
 * Destroy the memory Knex connection and reset singleton.
 * Call from resetSharedAdapters() and test teardown.
 */
export async function destroyMemoryKnex(): Promise<void> {
  if (memoryKnex) {
    await memoryKnex.destroy()
    memoryKnex = null
  }
}
